<template>
  <section>
    <label>
      {{label}}
    </label>
    <table class="table table-bordered"
           :key="randomValue" >
      <thead>
      <tr>
        <th></th>
        <th>Day</th>
        <th>Timings</th>
        <th>24 hours?</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(day, index) in days"
          v-bind:key="index"
      >
        <td>
          <br v-if="checkIfDayHasTimingConfiguration(day)"/>
          <div class="checkbox">
            <label>
              <input type="checkbox"
                     v-model="validDays[index]"/>
            </label>
          </div>
        </td>
        <td>
          <br v-if="checkIfDayHasTimingConfiguration(day)"/>
          {{day}}
          <br/>
          <a v-if="validDays[days.indexOf(day)] && !is24HoursAvailable[index]"
              type="button"
              v-on:click="addNewTimingSlot(day)"
              class="btn btn-primary btn-xs"
          >
            <i class="fa fa-plus"/>
          </a>
        </td>
        <td v-if="checkIfDayHasTimingConfiguration(day)">
          <div class="form-group">
            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Starting Time</th>
                <th>Closing Time</th>
                <th><i class="fa fa-bolt"></i></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(slots, slotIndex) in timingSlots[index]" v-bind:key="slotIndex">
                <td>
                  <div class="input-group startTimeClock"
                  >
                    <input type="text"
                           :id="'start-'+index+'-'+slotIndex"
                           v-model="slots.starting"
                           class="form-control"
                           readonly="readonly"
                           placeholder="Start time..." >
                    <span class="input-group-addon">
                  <span class="fa fa-clock-o"/>
                </span>
                  </div>
                </td>
                <td>
                  <div class="input-group endTimeClock"
                  >
                    <input type="text"
                           :id="'end-'+index+'-'+slotIndex"
                           class="form-control"
                           readonly="readonly"
                           v-model="slots.closing"
                           placeholder="End time..." >
                    <span class="input-group-addon">
                  <span class="fa fa-clock-o"/>
                </span>
                  </div>
                </td>
                <td>
                  <a
                      type="button"
                      v-on:click="deleteTimingSlot(day, index, slotIndex)"
                      class="btn btn-primary btn-xs"
                  >
                    <i class="fa fa-trash"/>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </td>
        <td v-else>
          <b>No Timing Configurations available.</b>
        </td>
        <td>
          <br v-if="checkIfDayHasTimingConfiguration(day)"/>
          <div class="checkbox">
            <label>
              <input type="checkbox" v-model="is24HoursAvailable[index]"/>
            </label>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {
  name: "TimingsComponentWithSlots",
  props:{
    label: {
      type: String,
      required: true
    },
    TimingsObj:{
      type: Array,
      required: true
    }
  },
  data () {
    return{
      randomValue: Math.random(),
      validDays: new Array(7).fill(false),
      timingSlots: [[], [], [], [], [], [], []],
      is24HoursAvailable: new Array(7).fill(false),
      days:["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      timingConfiguration: [],
    }
  },
  watch: {
    TimingsObj: async function (value) {
      if (value.length > 0 && typeof value === 'object') {
        this.timingConfiguration = value;
        await this.addBranchTimings(this.timingConfiguration);
        this.randomValue = Math.random();
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
      }
      setTimeout(() => {
        this.applyJqueryOnInput();
      }, 500);
    }
  },
  methods: {
    checkIfDayHasTimingConfiguration: function (day){
      let index = this.days.indexOf(day);
      return this.timingSlots[index] && this.timingSlots[index].length > 0 && this.validDays[index] && !this.is24HoursAvailable[index];
    },
    addNewTimingSlot: function (day) {
      this.timingSlots[this.days.indexOf(day)].push({
        "starting": null,
        "closing": null,
      });
      setTimeout(() => {
        this.jQueryForDealsTimingConfig(this.days.indexOf(day), this.timingSlots[this.days.indexOf(day)].length - 1);
      }, 500);
    },
    deleteTimingSlot: function (day, index, slotIndex){
      this.timingSlots[this.days.indexOf(day)].splice(slotIndex, 1);
    },
    jQueryForDealsTimingConfig: function (index, slotIndex) {
      let self = this;
      $("#start-" + index + "-" + slotIndex).datetimepicker({
        pickDate: false,
        format: 'hh:mmA',
        toolbarPlacement: 'bottom'
      }).on('dp.hide', function () {
        self.timingSlots[index][slotIndex].starting = $("#start-"+index+"-"+slotIndex).val();
      });
      $("#end-" + index + "-" + slotIndex).datetimepicker({
        pickDate: false,
        format: 'hh:mmA',
        toolbarPlacement: 'bottom'
      }).on('dp.hide', function () {
        self.timingSlots[index][slotIndex].closing = $("#end-"+index+"-"+slotIndex).val();
      });
    },
    applyJqueryOnInput: function (){
      this.timingSlots.forEach((timings, index) => {
        if(timings && timings.length > 0 ) {
          timings.forEach((slots, slotIndex) => {
            this.jQueryForDealsTimingConfig(index, slotIndex);
          })
        }
      })
    },
    isValidTimingConfig: function () {
      if (this.validDays.find(day => day === true) === undefined) {
        swal("Error", "Please make deal valid for at least one day!", "error");
        return false;
      }
      for (let index = 0; index < this.validDays.length; index++) {
        let day = this.validDays[index];
        if (day && !this.is24HoursAvailable[index]) {
          if(this.timingSlots[index].length === 0){
            swal("ERROR!", "Please select valid timing configuration of " + this.days[index] + " or mark it as 24 hours available", "error");
            return false;
          } else if (this.timingSlots[index].length > 0 && this.timingSlots[index].find( slot => slot.starting === null ) !== undefined){
            swal("ERROR!", "Please select valid start timing of " + this.days[index] + " or mark it as 24 hours available", "error");
            return false;
          } else if (this.timingSlots[index].length > 0 &&  this.timingSlots[index].find( slot => slot.closing === null ) !== undefined) {
            swal("ERROR!", "Please select valid end timing of " + this.days[index] + " or mark it as 24 hours available", "error");
            return false;
          }
        }
      }
      return true;
    },
    updateBranchTimings: function (){
      let branchTiming = [];
      if(this.isValidTimingConfig()) {
        this.days.forEach((name, index) => {
          if (this.validDays[index]) {
            let arr;
            if (this.is24HoursAvailable[index]) {
              arr = {
                "day": name,
                "is24Hours": this.is24HoursAvailable[index]
              }
            } else {
              arr = {
                "day" : name,
                "slots" : this.timingSlots[index]
              }
            }
            branchTiming.push(arr);
          }
        });
      }
      return branchTiming;
    },
    addBranchTimings: function (timings){
      return timings.forEach((time) => {
        if(time !== null){
          let day = this.days.indexOf(time.day);
          this.validDays[day] = true;
          if (time.is24Hours === undefined || !time.is24Hours) {
            this.timingSlots[day] = time.slots;
          } else {
            this.is24HoursAvailable[day] = true;
          }
        }
      });
    }
  },
}
</script>

<style scoped>

</style>